import { render } from "./TransactionType.vue?vue&type=template&id=10bfb367&scoped=true"
import script from "./TransactionType.vue?vue&type=script&lang=js"
export * from "./TransactionType.vue?vue&type=script&lang=js"

import "./TransactionType.vue?vue&type=style&index=0&id=10bfb367&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10bfb367"

export default script